import { Badge, Flex } from "antd"

import Icon from "../../Icon"

import "./styles.less"

const IntegrationAnimation = ({ icon, type }) => {
  if (type === "error") {
    return (
      <Flex gap={8} align="center" justify="center" className="integration-animation-container">
        <Flex align="center" justify="center" className="integration-icon-wrapper">
          <Badge
            count={
              <Flex
                align="center"
                justify="center"
                style={{
                  width: 12,
                  height: 12,
                  fontSize: 8,
                  background: "#ffffff",
                  borderRadius: "50%",
                  color: "#D71313"
                }}
              >
                <Icon type="triangle_exclamation2" />
              </Flex>
            }
            offset={[-2, 17]}
          >
            {icon}
          </Badge>
        </Flex>
      </Flex>
    )
  }

  return (
    <Flex gap={8} align="center" justify="center" className="integration-animation-container">
      <Flex align="center" justify="center" className="integration-icon-wrapper">
        <Icon type="logo" style={{ width: 20, height: 20 }} />
      </Flex>

      {/* Animated Dots */}
      <Flex vertical={true} gap={2} className="animated-dots">
        {/* Row 1 */}
        <Flex gap={3} align="center">
          <div className="dot" style={{ opacity: 0.79 }} />
          <div className="dot" style={{ opacity: 0.45 }} />
          <div className="dot" style={{ opacity: 0.66 }} />
          <div className="dot" style={{ opacity: 0.78 }} />
          <div className="dot" style={{ opacity: 0.26 }} />
          <div className="dot" style={{ opacity: 0.57 }} />
          <div className="dot" style={{ opacity: 0.31 }} />
          <div className="dot" style={{ opacity: 0.44 }} />
        </Flex>

        {/* Row 2 */}
        <Flex gap={3} align="center" style={{ position: "relative", right: "-2px" }}>
          <div className="dot" style={{ opacity: 0.14 }} />
          <div className="dot" style={{ opacity: 0.07 }} />
          <div className="dot" style={{ opacity: 0.19 }} />
          <div className="dot" style={{ opacity: 0.01 }} />
          <div className="dot" style={{ opacity: 0.12 }} />
          <div className="dot" style={{ opacity: 0.23 }} />
          <div className="dot" style={{ opacity: 0.23 }} />
          <div className="dot" style={{ opacity: 0.15 }} />
        </Flex>

        {/* Row 3 */}
        <Flex gap={3} align="center">
          <div className="dot" style={{ opacity: 0.35 }} />
          <div className="dot" style={{ opacity: 0.72 }} />
          <div className="dot" style={{ opacity: 0.06 }} />
          <div className="dot" style={{ opacity: 0.76 }} />
          <div className="dot" style={{ opacity: 0.82 }} />
          <div className="dot" style={{ opacity: 0.82 }} />
          <div className="dot" style={{ opacity: 0.53 }} />
          <div className="dot" style={{ opacity: 0.4 }} />
        </Flex>

        {/* Row 4 */}
        <Flex gap={3} align="center" style={{ position: "relative", right: "-2px" }}>
          <div className="dot" style={{ opacity: 0.11 }} />
          <div className="dot" style={{ opacity: 0.08 }} />
          <div className="dot" style={{ opacity: 0.16 }} />
          <div className="dot" style={{ opacity: 0.21 }} />
          <div className="dot" style={{ opacity: 0.06 }} />
          <div className="dot" style={{ opacity: 0.18 }} />
          <div className="dot" style={{ opacity: 0.01 }} />
          <div className="dot" style={{ opacity: 0.06 }} />
        </Flex>

        {/* Row 5 */}
        <Flex gap={3} align="center">
          <div className="dot" style={{ opacity: 0.23 }} />
          <div className="dot" style={{ opacity: 0.68 }} />
          <div className="dot" style={{ opacity: 0.11 }} />
          <div className="dot" style={{ opacity: 0.66 }} />
          <div className="dot" style={{ opacity: 0.49 }} />
          <div className="dot" style={{ opacity: 0.85 }} />
          <div className="dot" style={{ opacity: 0.08 }} />
          <div className="dot" style={{ opacity: 0.37 }} />
        </Flex>
      </Flex>

      <Flex align="center" justify="center" className="integration-icon-wrapper">
        {icon}
      </Flex>
    </Flex>
  )
}

export default IntegrationAnimation
